// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/flow_template.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Flow } from "./flow_pb.js";
import { FieldError, Ownership, Pagination, PaginationMeta, TagRef } from "./common_pb.js";

/**
 * @generated from enum tracker.v1.TemplateScope
 */
export enum TemplateScope {
  /**
   * @generated from enum value: TEMPLATE_SCOPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TEMPLATE_SCOPE_WORKSPACE = 1;
   */
  WORKSPACE = 1,

  /**
   * @generated from enum value: TEMPLATE_SCOPE_ORG = 2;
   */
  ORG = 2,

  /**
   * @generated from enum value: TEMPLATE_SCOPE_GLOBAL = 3;
   */
  GLOBAL = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(TemplateScope)
proto3.util.setEnumType(TemplateScope, "tracker.v1.TemplateScope", [
  { no: 0, name: "TEMPLATE_SCOPE_UNSPECIFIED" },
  { no: 1, name: "TEMPLATE_SCOPE_WORKSPACE" },
  { no: 2, name: "TEMPLATE_SCOPE_ORG" },
  { no: 3, name: "TEMPLATE_SCOPE_GLOBAL" },
]);

/**
 * @generated from enum tracker.v1.TemplateParameterKind
 */
export enum TemplateParameterKind {
  /**
   * @generated from enum value: TEMPLATE_PARAMETER_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TEMPLATE_PARAMETER_KIND_OFFER = 1;
   */
  OFFER = 1,

  /**
   * @generated from enum value: TEMPLATE_PARAMETER_KIND_LANDER = 2;
   */
  LANDER = 2,

  /**
   * @generated from enum value: TEMPLATE_PARAMETER_KIND_TEXT = 3;
   */
  TEXT = 3,

  /**
   * @generated from enum value: TEMPLATE_PARAMETER_KIND_NUMBER = 4;
   */
  NUMBER = 4,

  /**
   * @generated from enum value: TEMPLATE_PARAMETER_KIND_COUNTRY = 5;
   */
  COUNTRY = 5,

  /**
   * Pool kinds mark the blueprint node carrying `${key}` as an expansion
   * point: campaign-managed generation fans it out into one weighted clone
   * per entry of the campaign's flow_spec offers/landers. A template with
   * exactly one OFFER_POOL and one LANDER_POOL parameter is "campaign-ready".
   * InstantiateFlowTemplate treats a pool binding as a pool of one.
   *
   * @generated from enum value: TEMPLATE_PARAMETER_KIND_OFFER_POOL = 6;
   */
  OFFER_POOL = 6,

  /**
   * @generated from enum value: TEMPLATE_PARAMETER_KIND_LANDER_POOL = 7;
   */
  LANDER_POOL = 7,
}
// Retrieve enum metadata with: proto3.getEnumType(TemplateParameterKind)
proto3.util.setEnumType(TemplateParameterKind, "tracker.v1.TemplateParameterKind", [
  { no: 0, name: "TEMPLATE_PARAMETER_KIND_UNSPECIFIED" },
  { no: 1, name: "TEMPLATE_PARAMETER_KIND_OFFER" },
  { no: 2, name: "TEMPLATE_PARAMETER_KIND_LANDER" },
  { no: 3, name: "TEMPLATE_PARAMETER_KIND_TEXT" },
  { no: 4, name: "TEMPLATE_PARAMETER_KIND_NUMBER" },
  { no: 5, name: "TEMPLATE_PARAMETER_KIND_COUNTRY" },
  { no: 6, name: "TEMPLATE_PARAMETER_KIND_OFFER_POOL" },
  { no: 7, name: "TEMPLATE_PARAMETER_KIND_LANDER_POOL" },
]);

/**
 * FlowTemplate is a parameterizable Flow blueprint. `template_blueprint` is a
 * concrete Flow whose offer/lander references are placeholders the
 * instantiation step replaces.
 *
 * @generated from message tracker.v1.FlowTemplate
 */
export class FlowTemplate extends Message<FlowTemplate> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: string description = 4;
   */
  description = "";

  /**
   * @generated from field: string category = 5;
   */
  category = "";

  /**
   * @generated from field: string icon = 6;
   */
  icon = "";

  /**
   * @generated from field: tracker.v1.TemplateScope scope = 7;
   */
  scope = TemplateScope.UNSPECIFIED;

  /**
   * @generated from field: tracker.v1.Flow template_blueprint = 8;
   */
  templateBlueprint?: Flow;

  /**
   * @generated from field: repeated tracker.v1.TemplateParameter parameters = 9;
   */
  parameters: TemplateParameter[] = [];

  /**
   * @generated from field: repeated tracker.v1.TagRef tags = 10;
   */
  tags: TagRef[] = [];

  /**
   * @generated from field: tracker.v1.Ownership ownership = 11;
   */
  ownership?: Ownership;

  /**
   * @generated from field: string created_at = 12;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 13;
   */
  updatedAt = "";

  /**
   * Computed, read-only: the blueprint expands into a shape the CF edge
   * worker serves natively (weighted variants + offer pool + back-button).
   * False means campaigns on this template are served by the origin walk.
   *
   * @generated from field: bool edge_native = 14;
   */
  edgeNative = false;

  /**
   * Computed, read-only: declares exactly one OFFER_POOL and one LANDER_POOL
   * parameter, so it can drive a campaign's flow_spec.
   *
   * @generated from field: bool campaign_ready = 15;
   */
  campaignReady = false;

  constructor(data?: PartialMessage<FlowTemplate>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.FlowTemplate";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "scope", kind: "enum", T: proto3.getEnumType(TemplateScope) },
    { no: 8, name: "template_blueprint", kind: "message", T: Flow },
    { no: 9, name: "parameters", kind: "message", T: TemplateParameter, repeated: true },
    { no: 10, name: "tags", kind: "message", T: TagRef, repeated: true },
    { no: 11, name: "ownership", kind: "message", T: Ownership },
    { no: 12, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "edge_native", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "campaign_ready", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FlowTemplate {
    return new FlowTemplate().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FlowTemplate {
    return new FlowTemplate().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FlowTemplate {
    return new FlowTemplate().fromJsonString(jsonString, options);
  }

  static equals(a: FlowTemplate | PlainMessage<FlowTemplate> | undefined, b: FlowTemplate | PlainMessage<FlowTemplate> | undefined): boolean {
    return proto3.util.equals(FlowTemplate, a, b);
  }
}

/**
 * @generated from message tracker.v1.TemplateParameter
 */
export class TemplateParameter extends Message<TemplateParameter> {
  /**
   * referenced from blueprint as ${key}
   *
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from field: string label = 2;
   */
  label = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * @generated from field: string default_value = 4;
   */
  defaultValue = "";

  /**
   * @generated from field: tracker.v1.TemplateParameterKind kind = 5;
   */
  kind = TemplateParameterKind.UNSPECIFIED;

  constructor(data?: PartialMessage<TemplateParameter>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TemplateParameter";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "default_value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "kind", kind: "enum", T: proto3.getEnumType(TemplateParameterKind) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TemplateParameter {
    return new TemplateParameter().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TemplateParameter {
    return new TemplateParameter().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TemplateParameter {
    return new TemplateParameter().fromJsonString(jsonString, options);
  }

  static equals(a: TemplateParameter | PlainMessage<TemplateParameter> | undefined, b: TemplateParameter | PlainMessage<TemplateParameter> | undefined): boolean {
    return proto3.util.equals(TemplateParameter, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListFlowTemplatesRequest
 */
export class ListFlowTemplatesRequest extends Message<ListFlowTemplatesRequest> {
  /**
   * @generated from field: tracker.v1.Pagination pagination = 1;
   */
  pagination?: Pagination;

  /**
   * @generated from field: string search = 2;
   */
  search = "";

  /**
   * @generated from field: string category = 3;
   */
  category = "";

  constructor(data?: PartialMessage<ListFlowTemplatesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListFlowTemplatesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: Pagination },
    { no: 2, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFlowTemplatesRequest {
    return new ListFlowTemplatesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFlowTemplatesRequest {
    return new ListFlowTemplatesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFlowTemplatesRequest {
    return new ListFlowTemplatesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListFlowTemplatesRequest | PlainMessage<ListFlowTemplatesRequest> | undefined, b: ListFlowTemplatesRequest | PlainMessage<ListFlowTemplatesRequest> | undefined): boolean {
    return proto3.util.equals(ListFlowTemplatesRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListFlowTemplatesResponse
 */
export class ListFlowTemplatesResponse extends Message<ListFlowTemplatesResponse> {
  /**
   * @generated from field: repeated tracker.v1.FlowTemplate items = 1;
   */
  items: FlowTemplate[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  constructor(data?: PartialMessage<ListFlowTemplatesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListFlowTemplatesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: FlowTemplate, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFlowTemplatesResponse {
    return new ListFlowTemplatesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFlowTemplatesResponse {
    return new ListFlowTemplatesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFlowTemplatesResponse {
    return new ListFlowTemplatesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListFlowTemplatesResponse | PlainMessage<ListFlowTemplatesResponse> | undefined, b: ListFlowTemplatesResponse | PlainMessage<ListFlowTemplatesResponse> | undefined): boolean {
    return proto3.util.equals(ListFlowTemplatesResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetFlowTemplateRequest
 */
export class GetFlowTemplateRequest extends Message<GetFlowTemplateRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetFlowTemplateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetFlowTemplateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFlowTemplateRequest {
    return new GetFlowTemplateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFlowTemplateRequest {
    return new GetFlowTemplateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFlowTemplateRequest {
    return new GetFlowTemplateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFlowTemplateRequest | PlainMessage<GetFlowTemplateRequest> | undefined, b: GetFlowTemplateRequest | PlainMessage<GetFlowTemplateRequest> | undefined): boolean {
    return proto3.util.equals(GetFlowTemplateRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetFlowTemplateResponse
 */
export class GetFlowTemplateResponse extends Message<GetFlowTemplateResponse> {
  /**
   * @generated from field: tracker.v1.FlowTemplate template = 1;
   */
  template?: FlowTemplate;

  constructor(data?: PartialMessage<GetFlowTemplateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetFlowTemplateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "template", kind: "message", T: FlowTemplate },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFlowTemplateResponse {
    return new GetFlowTemplateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFlowTemplateResponse {
    return new GetFlowTemplateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFlowTemplateResponse {
    return new GetFlowTemplateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFlowTemplateResponse | PlainMessage<GetFlowTemplateResponse> | undefined, b: GetFlowTemplateResponse | PlainMessage<GetFlowTemplateResponse> | undefined): boolean {
    return proto3.util.equals(GetFlowTemplateResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateFlowTemplateRequest
 */
export class CreateFlowTemplateRequest extends Message<CreateFlowTemplateRequest> {
  /**
   * @generated from field: tracker.v1.FlowTemplate template = 1;
   */
  template?: FlowTemplate;

  constructor(data?: PartialMessage<CreateFlowTemplateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateFlowTemplateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "template", kind: "message", T: FlowTemplate },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateFlowTemplateRequest {
    return new CreateFlowTemplateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateFlowTemplateRequest {
    return new CreateFlowTemplateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateFlowTemplateRequest {
    return new CreateFlowTemplateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateFlowTemplateRequest | PlainMessage<CreateFlowTemplateRequest> | undefined, b: CreateFlowTemplateRequest | PlainMessage<CreateFlowTemplateRequest> | undefined): boolean {
    return proto3.util.equals(CreateFlowTemplateRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateFlowTemplateResponse
 */
export class CreateFlowTemplateResponse extends Message<CreateFlowTemplateResponse> {
  /**
   * @generated from field: tracker.v1.FlowTemplate template = 1;
   */
  template?: FlowTemplate;

  constructor(data?: PartialMessage<CreateFlowTemplateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateFlowTemplateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "template", kind: "message", T: FlowTemplate },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateFlowTemplateResponse {
    return new CreateFlowTemplateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateFlowTemplateResponse {
    return new CreateFlowTemplateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateFlowTemplateResponse {
    return new CreateFlowTemplateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateFlowTemplateResponse | PlainMessage<CreateFlowTemplateResponse> | undefined, b: CreateFlowTemplateResponse | PlainMessage<CreateFlowTemplateResponse> | undefined): boolean {
    return proto3.util.equals(CreateFlowTemplateResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateFlowTemplateRequest
 */
export class UpdateFlowTemplateRequest extends Message<UpdateFlowTemplateRequest> {
  /**
   * @generated from field: tracker.v1.FlowTemplate template = 1;
   */
  template?: FlowTemplate;

  constructor(data?: PartialMessage<UpdateFlowTemplateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateFlowTemplateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "template", kind: "message", T: FlowTemplate },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateFlowTemplateRequest {
    return new UpdateFlowTemplateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateFlowTemplateRequest {
    return new UpdateFlowTemplateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateFlowTemplateRequest {
    return new UpdateFlowTemplateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateFlowTemplateRequest | PlainMessage<UpdateFlowTemplateRequest> | undefined, b: UpdateFlowTemplateRequest | PlainMessage<UpdateFlowTemplateRequest> | undefined): boolean {
    return proto3.util.equals(UpdateFlowTemplateRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateFlowTemplateResponse
 */
export class UpdateFlowTemplateResponse extends Message<UpdateFlowTemplateResponse> {
  /**
   * @generated from field: tracker.v1.FlowTemplate template = 1;
   */
  template?: FlowTemplate;

  /**
   * Live campaigns whose managed flow was regenerated from the new blueprint
   * (campaign-ready templates propagate on save).
   *
   * @generated from field: int32 dependent_campaigns_regenerated = 2;
   */
  dependentCampaignsRegenerated = 0;

  /**
   * Campaigns that could not regenerate under the new template — their
   * last-good flow was kept and they keep serving. field names the campaign.
   *
   * @generated from field: repeated tracker.v1.FieldError dependent_warnings = 3;
   */
  dependentWarnings: FieldError[] = [];

  constructor(data?: PartialMessage<UpdateFlowTemplateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateFlowTemplateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "template", kind: "message", T: FlowTemplate },
    { no: 2, name: "dependent_campaigns_regenerated", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "dependent_warnings", kind: "message", T: FieldError, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateFlowTemplateResponse {
    return new UpdateFlowTemplateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateFlowTemplateResponse {
    return new UpdateFlowTemplateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateFlowTemplateResponse {
    return new UpdateFlowTemplateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateFlowTemplateResponse | PlainMessage<UpdateFlowTemplateResponse> | undefined, b: UpdateFlowTemplateResponse | PlainMessage<UpdateFlowTemplateResponse> | undefined): boolean {
    return proto3.util.equals(UpdateFlowTemplateResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.InstantiateFlowTemplateRequest
 */
export class InstantiateFlowTemplateRequest extends Message<InstantiateFlowTemplateRequest> {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId = "";

  /**
   * @generated from field: map<string, string> bindings = 2;
   */
  bindings: { [key: string]: string } = {};

  constructor(data?: PartialMessage<InstantiateFlowTemplateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.InstantiateFlowTemplateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "bindings", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InstantiateFlowTemplateRequest {
    return new InstantiateFlowTemplateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InstantiateFlowTemplateRequest {
    return new InstantiateFlowTemplateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InstantiateFlowTemplateRequest {
    return new InstantiateFlowTemplateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: InstantiateFlowTemplateRequest | PlainMessage<InstantiateFlowTemplateRequest> | undefined, b: InstantiateFlowTemplateRequest | PlainMessage<InstantiateFlowTemplateRequest> | undefined): boolean {
    return proto3.util.equals(InstantiateFlowTemplateRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.InstantiateFlowTemplateResponse
 */
export class InstantiateFlowTemplateResponse extends Message<InstantiateFlowTemplateResponse> {
  /**
   * @generated from field: tracker.v1.Flow flow = 1;
   */
  flow?: Flow;

  constructor(data?: PartialMessage<InstantiateFlowTemplateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.InstantiateFlowTemplateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "flow", kind: "message", T: Flow },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InstantiateFlowTemplateResponse {
    return new InstantiateFlowTemplateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InstantiateFlowTemplateResponse {
    return new InstantiateFlowTemplateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InstantiateFlowTemplateResponse {
    return new InstantiateFlowTemplateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: InstantiateFlowTemplateResponse | PlainMessage<InstantiateFlowTemplateResponse> | undefined, b: InstantiateFlowTemplateResponse | PlainMessage<InstantiateFlowTemplateResponse> | undefined): boolean {
    return proto3.util.equals(InstantiateFlowTemplateResponse, a, b);
  }
}

/**
 * ValidateFlowTemplate runs the template validation suite without persisting:
 * template-level checks (parameter manifest, undeclared/unused ${param}
 * references) plus the FULL flow validation suite against the blueprint with
 * parameters substituted by kind-appropriate sentinels server-side. Blueprint
 * errors come back with the same flow-relative paths ("nodes[2].weight") that
 * ValidateFlow emits, so editors share one error-painting path.
 *
 * @generated from message tracker.v1.ValidateFlowTemplateRequest
 */
export class ValidateFlowTemplateRequest extends Message<ValidateFlowTemplateRequest> {
  /**
   * @generated from field: tracker.v1.FlowTemplate template = 1;
   */
  template?: FlowTemplate;

  constructor(data?: PartialMessage<ValidateFlowTemplateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ValidateFlowTemplateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "template", kind: "message", T: FlowTemplate },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateFlowTemplateRequest {
    return new ValidateFlowTemplateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateFlowTemplateRequest {
    return new ValidateFlowTemplateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateFlowTemplateRequest {
    return new ValidateFlowTemplateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateFlowTemplateRequest | PlainMessage<ValidateFlowTemplateRequest> | undefined, b: ValidateFlowTemplateRequest | PlainMessage<ValidateFlowTemplateRequest> | undefined): boolean {
    return proto3.util.equals(ValidateFlowTemplateRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ValidateFlowTemplateResponse
 */
export class ValidateFlowTemplateResponse extends Message<ValidateFlowTemplateResponse> {
  /**
   * @generated from field: repeated tracker.v1.FieldError errors = 1;
   */
  errors: FieldError[] = [];

  constructor(data?: PartialMessage<ValidateFlowTemplateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ValidateFlowTemplateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "errors", kind: "message", T: FieldError, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateFlowTemplateResponse {
    return new ValidateFlowTemplateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateFlowTemplateResponse {
    return new ValidateFlowTemplateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateFlowTemplateResponse {
    return new ValidateFlowTemplateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateFlowTemplateResponse | PlainMessage<ValidateFlowTemplateResponse> | undefined, b: ValidateFlowTemplateResponse | PlainMessage<ValidateFlowTemplateResponse> | undefined): boolean {
    return proto3.util.equals(ValidateFlowTemplateResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.ArchiveFlowTemplateRequest
 */
export class ArchiveFlowTemplateRequest extends Message<ArchiveFlowTemplateRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<ArchiveFlowTemplateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ArchiveFlowTemplateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveFlowTemplateRequest {
    return new ArchiveFlowTemplateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveFlowTemplateRequest {
    return new ArchiveFlowTemplateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveFlowTemplateRequest {
    return new ArchiveFlowTemplateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveFlowTemplateRequest | PlainMessage<ArchiveFlowTemplateRequest> | undefined, b: ArchiveFlowTemplateRequest | PlainMessage<ArchiveFlowTemplateRequest> | undefined): boolean {
    return proto3.util.equals(ArchiveFlowTemplateRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ArchiveFlowTemplateResponse
 */
export class ArchiveFlowTemplateResponse extends Message<ArchiveFlowTemplateResponse> {
  constructor(data?: PartialMessage<ArchiveFlowTemplateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ArchiveFlowTemplateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ArchiveFlowTemplateResponse {
    return new ArchiveFlowTemplateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ArchiveFlowTemplateResponse {
    return new ArchiveFlowTemplateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ArchiveFlowTemplateResponse {
    return new ArchiveFlowTemplateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ArchiveFlowTemplateResponse | PlainMessage<ArchiveFlowTemplateResponse> | undefined, b: ArchiveFlowTemplateResponse | PlainMessage<ArchiveFlowTemplateResponse> | undefined): boolean {
    return proto3.util.equals(ArchiveFlowTemplateResponse, a, b);
  }
}

/**
 * FlowTemplateVersion is an append-only snapshot of a template's content.
 * The FE renders the history timeline; Restore replays a snapshot back into
 * the live row (which itself becomes a new version).
 *
 * @generated from message tracker.v1.FlowTemplateVersion
 */
export class FlowTemplateVersion extends Message<FlowTemplateVersion> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string template_id = 2;
   */
  templateId = "";

  /**
   * @generated from field: int32 version = 3;
   */
  version = 0;

  /**
   * @generated from field: string name = 4;
   */
  name = "";

  /**
   * @generated from field: string description = 5;
   */
  description = "";

  /**
   * @generated from field: string category = 6;
   */
  category = "";

  /**
   * @generated from field: string icon = 7;
   */
  icon = "";

  /**
   * @generated from field: tracker.v1.TemplateScope scope = 8;
   */
  scope = TemplateScope.UNSPECIFIED;

  /**
   * @generated from field: tracker.v1.Flow template_blueprint = 9;
   */
  templateBlueprint?: Flow;

  /**
   * @generated from field: repeated tracker.v1.TemplateParameter parameters = 10;
   */
  parameters: TemplateParameter[] = [];

  /**
   * @generated from field: string created_at = 11;
   */
  createdAt = "";

  /**
   * @generated from field: string created_by = 12;
   */
  createdBy = "";

  /**
   * @generated from field: string note = 13;
   */
  note = "";

  constructor(data?: PartialMessage<FlowTemplateVersion>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.FlowTemplateVersion";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "version", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "scope", kind: "enum", T: proto3.getEnumType(TemplateScope) },
    { no: 9, name: "template_blueprint", kind: "message", T: Flow },
    { no: 10, name: "parameters", kind: "message", T: TemplateParameter, repeated: true },
    { no: 11, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FlowTemplateVersion {
    return new FlowTemplateVersion().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FlowTemplateVersion {
    return new FlowTemplateVersion().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FlowTemplateVersion {
    return new FlowTemplateVersion().fromJsonString(jsonString, options);
  }

  static equals(a: FlowTemplateVersion | PlainMessage<FlowTemplateVersion> | undefined, b: FlowTemplateVersion | PlainMessage<FlowTemplateVersion> | undefined): boolean {
    return proto3.util.equals(FlowTemplateVersion, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListFlowTemplateVersionsRequest
 */
export class ListFlowTemplateVersionsRequest extends Message<ListFlowTemplateVersionsRequest> {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId = "";

  /**
   * @generated from field: tracker.v1.Pagination pagination = 2;
   */
  pagination?: Pagination;

  constructor(data?: PartialMessage<ListFlowTemplateVersionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListFlowTemplateVersionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "pagination", kind: "message", T: Pagination },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFlowTemplateVersionsRequest {
    return new ListFlowTemplateVersionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFlowTemplateVersionsRequest {
    return new ListFlowTemplateVersionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFlowTemplateVersionsRequest {
    return new ListFlowTemplateVersionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListFlowTemplateVersionsRequest | PlainMessage<ListFlowTemplateVersionsRequest> | undefined, b: ListFlowTemplateVersionsRequest | PlainMessage<ListFlowTemplateVersionsRequest> | undefined): boolean {
    return proto3.util.equals(ListFlowTemplateVersionsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListFlowTemplateVersionsResponse
 */
export class ListFlowTemplateVersionsResponse extends Message<ListFlowTemplateVersionsResponse> {
  /**
   * @generated from field: repeated tracker.v1.FlowTemplateVersion items = 1;
   */
  items: FlowTemplateVersion[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  constructor(data?: PartialMessage<ListFlowTemplateVersionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListFlowTemplateVersionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: FlowTemplateVersion, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListFlowTemplateVersionsResponse {
    return new ListFlowTemplateVersionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListFlowTemplateVersionsResponse {
    return new ListFlowTemplateVersionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListFlowTemplateVersionsResponse {
    return new ListFlowTemplateVersionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListFlowTemplateVersionsResponse | PlainMessage<ListFlowTemplateVersionsResponse> | undefined, b: ListFlowTemplateVersionsResponse | PlainMessage<ListFlowTemplateVersionsResponse> | undefined): boolean {
    return proto3.util.equals(ListFlowTemplateVersionsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetFlowTemplateVersionRequest
 */
export class GetFlowTemplateVersionRequest extends Message<GetFlowTemplateVersionRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetFlowTemplateVersionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetFlowTemplateVersionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFlowTemplateVersionRequest {
    return new GetFlowTemplateVersionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFlowTemplateVersionRequest {
    return new GetFlowTemplateVersionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFlowTemplateVersionRequest {
    return new GetFlowTemplateVersionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFlowTemplateVersionRequest | PlainMessage<GetFlowTemplateVersionRequest> | undefined, b: GetFlowTemplateVersionRequest | PlainMessage<GetFlowTemplateVersionRequest> | undefined): boolean {
    return proto3.util.equals(GetFlowTemplateVersionRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetFlowTemplateVersionResponse
 */
export class GetFlowTemplateVersionResponse extends Message<GetFlowTemplateVersionResponse> {
  /**
   * @generated from field: tracker.v1.FlowTemplateVersion version = 1;
   */
  version?: FlowTemplateVersion;

  constructor(data?: PartialMessage<GetFlowTemplateVersionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetFlowTemplateVersionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "version", kind: "message", T: FlowTemplateVersion },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFlowTemplateVersionResponse {
    return new GetFlowTemplateVersionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFlowTemplateVersionResponse {
    return new GetFlowTemplateVersionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFlowTemplateVersionResponse {
    return new GetFlowTemplateVersionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFlowTemplateVersionResponse | PlainMessage<GetFlowTemplateVersionResponse> | undefined, b: GetFlowTemplateVersionResponse | PlainMessage<GetFlowTemplateVersionResponse> | undefined): boolean {
    return proto3.util.equals(GetFlowTemplateVersionResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.RestoreFlowTemplateVersionRequest
 */
export class RestoreFlowTemplateVersionRequest extends Message<RestoreFlowTemplateVersionRequest> {
  /**
   * @generated from field: string version_id = 1;
   */
  versionId = "";

  /**
   * optional rollback rationale
   *
   * @generated from field: string note = 2;
   */
  note = "";

  constructor(data?: PartialMessage<RestoreFlowTemplateVersionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.RestoreFlowTemplateVersionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "version_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RestoreFlowTemplateVersionRequest {
    return new RestoreFlowTemplateVersionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RestoreFlowTemplateVersionRequest {
    return new RestoreFlowTemplateVersionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RestoreFlowTemplateVersionRequest {
    return new RestoreFlowTemplateVersionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RestoreFlowTemplateVersionRequest | PlainMessage<RestoreFlowTemplateVersionRequest> | undefined, b: RestoreFlowTemplateVersionRequest | PlainMessage<RestoreFlowTemplateVersionRequest> | undefined): boolean {
    return proto3.util.equals(RestoreFlowTemplateVersionRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.RestoreFlowTemplateVersionResponse
 */
export class RestoreFlowTemplateVersionResponse extends Message<RestoreFlowTemplateVersionResponse> {
  /**
   * @generated from field: tracker.v1.FlowTemplate template = 1;
   */
  template?: FlowTemplate;

  /**
   * @generated from field: tracker.v1.FlowTemplateVersion captured_pre_restore = 2;
   */
  capturedPreRestore?: FlowTemplateVersion;

  /**
   * Same propagation report as UpdateFlowTemplateResponse — a restore is an
   * update and re-propagates to dependent campaigns.
   *
   * @generated from field: int32 dependent_campaigns_regenerated = 3;
   */
  dependentCampaignsRegenerated = 0;

  /**
   * @generated from field: repeated tracker.v1.FieldError dependent_warnings = 4;
   */
  dependentWarnings: FieldError[] = [];

  constructor(data?: PartialMessage<RestoreFlowTemplateVersionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.RestoreFlowTemplateVersionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "template", kind: "message", T: FlowTemplate },
    { no: 2, name: "captured_pre_restore", kind: "message", T: FlowTemplateVersion },
    { no: 3, name: "dependent_campaigns_regenerated", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "dependent_warnings", kind: "message", T: FieldError, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RestoreFlowTemplateVersionResponse {
    return new RestoreFlowTemplateVersionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RestoreFlowTemplateVersionResponse {
    return new RestoreFlowTemplateVersionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RestoreFlowTemplateVersionResponse {
    return new RestoreFlowTemplateVersionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RestoreFlowTemplateVersionResponse | PlainMessage<RestoreFlowTemplateVersionResponse> | undefined, b: RestoreFlowTemplateVersionResponse | PlainMessage<RestoreFlowTemplateVersionResponse> | undefined): boolean {
    return proto3.util.equals(RestoreFlowTemplateVersionResponse, a, b);
  }
}

